export class SampStatSearchFields {
  CustomerId: number;
  LabIds: any;
  ReceivedFrom: string;
  ReceivedTo: string;
  LabName: string;
  PageNo: number;
  PageSize: number;
  IsForExcel: boolean;
}